module.exports = __webpack_public_path__ + "img/bsk.aec0b136.jpg";